var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import { appleAuth, appleAuthAndroid, } from '@invertase/react-native-apple-authentication';
import { login } from '@react-native-seoul/kakao-login';
import { useAtom } from 'jotai';
import React, { useMemo, useState } from 'react';
import { Image, Platform, Text, useWindowDimensions, View, } from 'react-native';
import Carousel from 'react-native-reanimated-carousel';
import Config from 'react-native-config';
import AppleLogo from '@/assets/icon/ic_logo_apple.svg';
import KakaoLogo from '@/assets/icon/ic_logo_kakao.svg';
import { accessTokenAtom, useMe } from '@/atoms/Auth';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { ScreenLayout } from '@/components/ScreenLayout';
import useAppComponents from '@/hooks/useAppComponents';
import { useEnsureAnonymousUser } from '@/hooks/useEnsureAnonymousUser';
import Logger from '@/logging/Logger';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import { appleWebSignIn } from '@/utils/socialLoginWeb';
import ToastUtils from '@/utils/ToastUtils';
const LoginWith3rdParty = ({ onKakaoButtonPressed, onAppleButtonPressed, onGuestButtonPressed, }) => {
    return (_jsxs(_Fragment, { children: [_jsxs(SccTouchableOpacity, { className: "flex-row items-center justify-center p-[16px] w-full h-[58px] rounded-[12px] bg-[#FEE500]", elementName: "login_kakao_button", onPress: onKakaoButtonPressed, children: [_jsx(View, { className: "absolute left-[16px] top-[17px]", children: _jsx(KakaoLogo, {}) }), _jsx(Text, { className: "font-pretendard-bold text-[16px] leading-[24px] text-black-a80", children: "\uCE74\uCE74\uC624\uD1A1\uC73C\uB85C \uACC4\uC18D\uD558\uAE30" })] }), (Platform.OS === 'ios' ||
                (Platform.OS === 'web' && !!Config.APPLE_WEB_SERVICE_ID)) && (_jsxs(SccTouchableOpacity, { className: "flex-row items-center justify-center p-[16px] w-full h-[58px] rounded-[12px] border-[1px] border-black bg-white", elementName: "login_apple_button", onPress: onAppleButtonPressed, children: [_jsx(View, { className: "absolute left-[16px] top-[17px]", children: _jsx(AppleLogo, {}) }), _jsx(Text, { className: "font-pretendard-bold text-[16px] leading-[24px]", children: "Apple\uB85C \uACC4\uC18D\uD558\uAE30" })] })), onGuestButtonPressed && (_jsx(SccTouchableOpacity, { className: "flex-row items-center justify-center p-[16px] w-full h-[58px] rounded-[12px] bg-white", elementName: "login_guest_button", onPress: onGuestButtonPressed, children: _jsx(Text, { className: "leading-[24px] text-[14px] font-pretendard-regular text-gray-90", children: "\uBE44\uD68C\uC6D0 \uB458\uB7EC\uBCF4\uAE30" }) }))] }));
};
export default function LoginScreen({ navigation, route }) {
    var _a;
    const { api } = useAppComponents();
    const [accessToken, setAccessToken] = useAtom(accessTokenAtom);
    const { setUserInfo } = useMe();
    const ensureAnonymousUser = useEnsureAnonymousUser();
    const [activeSlide, setActiveSlide] = useState(0);
    const { asModal, redirect } = (_a = route.params) !== null && _a !== void 0 ? _a : {};
    // 로그인 진입점: navigation stack의 직전 라우트 이름을 사용한다.
    // 웹에서 스택에 이전 화면이 없으면(deep link/직접 접속) document.referrer로 폴백.
    const entryPoint = useMemo(() => {
        var _a, _b, _c, _d;
        const state = navigation.getState();
        const currentIndex = state.index;
        if (currentIndex > 0) {
            return (_b = (_a = state.routes[currentIndex - 1]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'unknown';
        }
        if (Platform.OS === 'web') {
            const referrer = (_d = (_c = globalThis.document) === null || _c === void 0 ? void 0 : _c.referrer) !== null && _d !== void 0 ? _d : '';
            if (referrer) {
                try {
                    return new URL(referrer).pathname;
                }
                catch (_e) {
                    return referrer;
                }
            }
        }
        return 'direct';
    }, []);
    // 로그인 완료 후 이동: 모달이면 닫고, (웹) redirect 가 있으면 그 경로로, 없으면 홈.
    function goAfterLogin() {
        if (asModal) {
            navigation.goBack();
            return;
        }
        if (Platform.OS === 'web') {
            const loc = globalThis.location;
            // route.params 로 안 들어오는 경우가 있어 URL 쿼리도 함께 확인.
            const fromQuery = (loc === null || loc === void 0 ? void 0 : loc.search)
                ? new URLSearchParams(loc.search).get('redirect')
                : null;
            const dest = redirect || fromQuery || undefined;
            if (dest && dest.startsWith('/') && !dest.startsWith('/login')) {
                loc === null || loc === void 0 ? void 0 : loc.assign(dest);
                return;
            }
        }
        navigation.replace('Main');
    }
    function afterSocialLogin(user, tokens) {
        return __awaiter(this, void 0, void 0, function* () {
            // 미가입 유저 : 앱 종료 후 재시작 시 로그인 되지 않도록 토큰을 저장하지 않는다
            if (!user.email) {
                return navigation.replace('Signup', {
                    token: tokens.accessToken,
                    asModal,
                });
            }
            // 가입 유저
            setAccessToken(tokens.accessToken);
            yield setUserInfo(user);
            goAfterLogin();
        });
    }
    function kakaoLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // loginWithKakaoAccount() 는 웹뷰를 통해 로그인 - 이메일/비밀번호를 통한 로그인
                // login()은 카카오톡 앱을 통해 로그인!
                const kakaoTokens = yield login();
                // 라이브러리에서 반환하는게 Date 가 아닌 utc 시간 문자열이라 변환
                const fixedAccessTokenExpiresAt = new Date(kakaoTokens.accessTokenExpiresAt);
                const fixedRefreshTokenExpiresAt = new Date(kakaoTokens.refreshTokenExpiresAt);
                const res = yield api.loginWithKakaoPost({
                    kakaoTokens: {
                        accessToken: kakaoTokens.accessToken,
                        refreshToken: kakaoTokens.refreshToken,
                        idToken: kakaoTokens.idToken,
                        accessTokenExpiresAt: {
                            value: fixedAccessTokenExpiresAt.getTime(),
                        },
                        refreshTokenExpiresAt: {
                            value: fixedRefreshTokenExpiresAt.getTime(),
                        },
                    },
                });
                const { authTokens, user } = res.data;
                yield afterSocialLogin(user, authTokens);
            }
            catch (e) {
                // user cancelled kakao log
                Logger.logError(e);
                ToastUtils.show('로그인 중 문제가 발생했습니다.');
            }
        });
    }
    function androidAppleLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            appleAuthAndroid.configure({
                clientId: 'club.staircrusher.android.sandbox',
                // Return URL added to your Apple dev console. We intercept this redirect, but it must still match
                // the URL you provided to Apple. It can be an empty route on your backend as it's never called.
                redirectUri: 'https://api.dev.staircrusher.club/auth/callback',
                // The type of response requested - code, id_token, or both.
                responseType: appleAuthAndroid.ResponseType.ALL,
                // The amount of user information requested from Apple.
                scope: appleAuthAndroid.Scope.ALL,
                // Random nonce value that will be SHA256 hashed before sending to Apple.
                // nonce: '',
                // Unique state value used to prevent CSRF attacks. A UUID will be generated if nothing is provided.
                // state,
            });
            const response = yield appleAuthAndroid.signIn();
            const res = yield api.loginWithApplePost({
                authorizationCode: (_a = response.code) !== null && _a !== void 0 ? _a : '',
                identityToken: (_b = response.id_token) !== null && _b !== void 0 ? _b : '',
            });
            const { authTokens, user } = res.data;
            yield afterSocialLogin(user, authTokens);
        });
    }
    function iosAppleLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            // performs login request
            const appleAuthRequestResponse = yield appleAuth.performRequest({
                requestedOperation: appleAuth.Operation.LOGIN,
                // Note: it appears putting FULL_NAME first is important, see issue #293
                requestedScopes: [appleAuth.Scope.FULL_NAME, appleAuth.Scope.EMAIL],
            });
            // get current authentication state for user
            // /!\ This method must be tested on a real device. On the iOS simulator it always throws an error.
            const credentialState = yield appleAuth.getCredentialStateForUser(appleAuthRequestResponse.user);
            // use credentialState response to ensure the user is authenticated
            if (credentialState === appleAuth.State.AUTHORIZED) {
                const res = yield api.loginWithApplePost({
                    authorizationCode: (_a = appleAuthRequestResponse.authorizationCode) !== null && _a !== void 0 ? _a : '',
                    identityToken: (_b = appleAuthRequestResponse.identityToken) !== null && _b !== void 0 ? _b : '',
                });
                const { authTokens, user } = res.data;
                yield afterSocialLogin(user, authTokens);
            }
        });
    }
    function webAppleLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            const { authorizationCode, identityToken } = yield appleWebSignIn();
            const res = yield api.loginWithApplePost({
                authorizationCode,
                identityToken,
            });
            const { authTokens, user } = res.data;
            yield afterSocialLogin(user, authTokens);
        });
    }
    function appleLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (Platform.OS === 'web') {
                    yield webAppleLogin();
                }
                else if (Platform.OS === 'android') {
                    yield androidAppleLogin();
                }
                else {
                    yield iosAppleLogin();
                }
            }
            catch (e) {
                ToastUtils.show('로그인 중 문제가 발생했습니다.');
            }
        });
    }
    function guestLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // 모달로 열린 경우 : 이미 토큰이 있는 경우 닫아버린다
                if (asModal && accessToken) {
                    navigation.goBack();
                    return;
                }
                yield ensureAnonymousUser();
                goAfterLogin();
            }
            catch (e) {
                ToastUtils.show('로그인 중 문제가 발생했습니다.');
            }
        });
    }
    const windowWidth = useWindowDimensions().width;
    const slides = [
        {
            heading: '접근성지도',
            title: '한눈에 접근난이도를\n파악해요',
            image: require('@/assets/img/value-map.png'),
        },
        {
            heading: '뿌클로드',
            title: '이동약자가 직접 작성한\n장소 리뷰 확인해요',
            image: require('@/assets/img/value-pcrd.png'),
        },
        {
            heading: '정보등록',
            title: '접근성 정보를\n함께 모아요',
            image: require('@/assets/img/value-gather.png'),
        },
        {
            heading: '정복활동 리포트',
            title: '정복활동 리포트로\n매일매일의 보람을 모아요',
            image: require('@/assets/img/value-report.png'),
        },
    ];
    function renderSlide({ item }) {
        return (_jsxs(View, { className: "w-full items-center", children: [_jsx(Text, { className: "text-[13px] leading-[17px] font-pretendard-bold text-blue-50 text-center mb-[10px]", children: item.heading }), _jsx(Text, { className: "text-[22px] leading-[31px] font-pretendard-semibold text-black text-center", children: item.title }), _jsx(Image, { className: "w-full aspect-[375/310] h-[310px]", source: item.image })] }));
    }
    return (_jsx(LogParamsProvider, { params: { entry_point: entryPoint }, children: _jsx(ScreenLayout, { isHeaderVisible: false, safeAreaEdges: ['bottom'], style: { backgroundColor: 'white' }, children: _jsxs(View, { className: `flex-1 ${Platform.OS === 'web' ? 'justify-center' : 'justify-end'}`, children: [_jsxs(View, { className: "mt-[40px] w-full h-[440px]", children: [_jsx(Carousel, { data: slides, width: windowWidth, loop: true, renderItem: renderSlide, onProgressChange: (_, i) => setActiveSlide(i), onConfigurePanGesture: gestureChain => {
                                    gestureChain.activeOffsetX([-10, 10]);
                                }, autoPlay: true, autoPlayInterval: 5000 }), _jsx(View, { className: "flex-row gap-[8px] justify-center mt-[10px]", children: slides.map((_, index) => (_jsx(View, { className: "w-[8px] h-[8px] rounded-[4px] bg-gray-20", children: _jsx(View, { className: "absolute top-0 left-0 w-[8px] h-[8px] rounded-[4px] bg-blue-50", style: {
                                            opacity: getDotColor(index, activeSlide, slides.length),
                                        } }) }, index))) })] }), _jsx(View, { className: "justify-end px-[20px] gap-[10px] mt-[58px]", children: _jsx(LoginWith3rdParty, { onKakaoButtonPressed: kakaoLogin, onAppleButtonPressed: appleLogin, onGuestButtonPressed: guestLogin }) })] }) }) }));
}
function getDotColor(index, value, period) {
    const distance = Math.min(Math.abs(value - index), Math.abs(value - index - period));
    if (distance <= 1) {
        return 1 - distance;
    }
    else {
        return 0;
    }
}
